import Select, { components } from "react-select";

const MultiValueLimit = ({ index, getValue, ...props }) => {
  const maxToShow = 3;
  const selected = getValue();

  if (index < maxToShow) return <components.MultiValue {...props} />;
  if (index === maxToShow) {
    return (
      <div className="react-select__multi-value__more px-1 text-muted">
        +{selected.length - maxToShow} more
      </div>
    );
  }
  return null;
};

const CustomMultiSelect = ({
  options,
  value,
  onChange,
  placeholder,
  isSelectAllEnabled = true,
  withSelectAllFn,
  handleMultiSelectChange,
  path,
  ...rest
}) => {
  const finalOptions =
    isSelectAllEnabled && withSelectAllFn ? withSelectAllFn(options) : options;

  const handleChange = (selected) => {
    if (selected?.some((opt) => opt.value === "*")) {
      handleMultiSelectChange(options, path);
    } else {
      handleMultiSelectChange(selected, path);
    }
  };

  return (
    <Select
      isMulti
      options={finalOptions}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      components={{ MultiValue: MultiValueLimit }}
      closeMenuOnSelect={false}
      {...rest}
    />
  );
};

export default CustomMultiSelect;
